import { Component, inject, OnInit } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';

import { AuthenticationService } from '@core/auth/authentication.service';
import { PageHeaderComponent } from '@shared/components/common/page-header/page-header.component';
import { StockSemen } from './semen/stock-semen';
import { StockEmbrionesCongelados } from './embriones/stock-embriones-congelados/stock-embriones-congelados';
import { StockEmbrionesFrescos } from './frescos/stock-embriones-frescos';

/** Índice de cada pestaña, para poder volver a la que corresponde por query param. */
const TABS = ['semen', 'embriones', 'frescos'];

/** 2026-10-08: cada pestaña tiene su permiso de Stock. */
const MODULO_TAB: Record<string, string> = {
  semen: 'stock.semen',
  embriones: 'stock.congelados',
  frescos: 'stock.frescos',
};

@Component({
  selector: 'app-stock-laboratorio',
  imports: [
    MatTabsModule,
    PageHeaderComponent,
    StockSemen,
    StockEmbrionesCongelados,
    StockEmbrionesFrescos,
  ],
  templateUrl: './stock.html',
})
export class StockLaboratorio implements OnInit {
  selectedIndex = 0;

  private route = inject(ActivatedRoute);
  private auth = inject(AuthenticationService);

  /** Las pestañas que el usuario puede ver, en orden. */
  readonly tabs = TABS.filter(tab => this.auth.hasPermission(MODULO_TAB[tab], 'view'));

  ngOnInit(): void {
    const tab = this.route.snapshot.queryParamMap.get('tab');
    const index = this.tabs.indexOf(tab ?? '');

    if (index >= 0) {
      this.selectedIndex = index;
    }
  }
}
